function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 12H6V16H10V12Z",
  fill: "#002A95"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 0H6V4H10V0Z",
  fill: "#002A95"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16 12H12V16H16V12Z",
  fill: "#002A95"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4 12H0V16H4V12Z",
  fill: "#002A95"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3 9H7V11H9V9H13V11H15V8C15 7.4 14.6 7 14 7H9V5H7V7H2C1.4 7 1 7.4 1 8V11H3V9Z",
  fill: "#002A95"
});

var SvgWorkflows = function SvgWorkflows(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWorkflows, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Workflows.297286fb.svg";
export { ForwardRef as ReactComponent };